export default __webpack_public_path__ + "static/media/BrazingImg.e446f83a.jpg";